import React from 'react'
import { Link } from "react-router-dom"

class Trailer extends React.Component {
  constructor(props) {
    super(props)
    this.parseYTUrl = this.parseYTUrl.bind(this)
    this.close = this.close.bind(this)
  }
  parseYTUrl(url){
    var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
    var match = url.match(regExp);
    return (match&&match[7].length===11)? match[7] : false;
  }
  close() {
    this.props.close()
  }
  render() {
    return (
      <div className="trailer">
        <div className="header">
          <div className="back" onClick={() => {this.close()}}></div>
          <p className="heading"><Link to={"/movie/"+this.props.filmId} className="tomvi" onClick={() => {this.close()}}>{this.props.filmName}</Link></p>
          <div className="close" onClick={() => {this.close()}}></div>
        </div>
        <iframe title="trailer" src={"//www.youtube.com/embed/"+this.parseYTUrl(this.props.trailerUrl)+"?autoplay=1&autohide=1&controls=1&showinfo=0&rel=0"} frameBorder="0"></iframe>
      </div>
    ) 
  }
}

export default Trailer


// WEBPACK FOOTER //
// ./src/components/snippets/Trailer.jsx